import React, { useState } from 'react';
import {
  Box, Button, Card, CardContent, TextField, Typography,
  Dialog, DialogTitle, DialogContent, DialogActions, Stack, useMediaQuery, useTheme
} from '@mui/material';
import axios from '../api/axiosConfig';

const Login = ({ onLoginSuccess }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // 모바일 화면 감지

  // 로그인 Form State
  const [loginId, setLoginId] = useState('');
  const [password, setPassword] = useState('');

  // 회원가입 Modal State
  const [openSignUp, setOpenSignUp] = useState(false);
  const [signUpData, setSignUpData] = useState({
    loginId: '',
    password: '',
    email: '',
    certNumber: '',
    name: '',
    birthDate: '',
    phone: '',
    address: ''
  });

  // 로그인 제출
const handleLogin = async (e) => {
  e.preventDefault();
  try {
    const response = await axios.post('/api/member/login', { loginId, password });
    
    // 1. 백엔드에서 내려주는 토큰 추출 (토큰 필드명 확인: token 또는 accessToken)
    const token = response.data.token || response.data.accessToken || (typeof response.data === 'string' ? response.data : null);
    
    if (token) {
      // 2. localStorage에 토큰 저장 (axiosConfig.js 인터셉터에서 읽을 키명 'token')
      localStorage.setItem('token', token);
      console.log('로그인 성공 및 토큰 저장 완료:', token);
    } else {
      console.warn('응답 데이터에 토큰이 포함되지 않았습니다:', response.data);
    }

    if (onLoginSuccess) onLoginSuccess(response.data);
  } catch (error) {
    alert(error.response?.data || '로그인에 실패했습니다.');
  }
};

  // 회원가입 Input 변경 핸들러
  const handleSignUpChange = (e) => {
    const { name, value } = e.target;
    setSignUpData((prev) => ({ ...prev, [name]: value }));
  };

  // 회원가입 제출
  const handleSignUpSubmit = async () => {
    if (!signUpData.name || !signUpData.password || !signUpData.certNumber || !signUpData.email) {
      alert('이름, 비밀번호, 이메일, 교원자격증 번호는 필수 입력입니다.');
      return;
    }

    try {
      await axios.post('/api/member/signup', signUpData);
      alert('회원가입이 완료되었습니다. 로그인해 주세요.');
      setOpenSignUp(false);
      setSignUpData({ 
        loginId: '', password: '', email: '', certNumber: '', 
        name: '', birthDate: '', phone: '', address: '' 
      });
    } catch (error) {
      alert(error.response?.data?.message || '회원가입 실패');
    }
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', bgcolor: '#f5f5f5', px: 2 }}>
      <Card sx={{ maxWidth: 400, width: '100%', p: { xs: 1, sm: 2 }, boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h5" align="center" gutterBottom sx={{ fontWeight: 'bold' }}>
            KSLTA 로그인
          </Typography>

          <Box component="form" onSubmit={handleLogin} sx={{ mt: 2 }}>
            <TextField
              fullWidth
              label="아이디 또는 이메일"
              margin="normal"
              value={loginId}
              onChange={(e) => setLoginId(e.target.value)}
              required
            />
            <TextField
              fullWidth
              label="비밀번호"
              type="password"
              margin="normal"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <Button type="submit" fullWidth variant="contained" size="large" sx={{ mt: 3, mb: 1, py: 1.2 }}>
              로그인
            </Button>

            {/*
            <Button
              fullWidth
              variant="text"
              color="secondary"
              onClick={() => setOpenSignUp(true)}
            >
              신규 회원가입 (테스트/개발용)
            </Button>
            */}
          </Box>
        </CardContent>
      </Card>

      {/* ==================== [회원가입 모달] ==================== */}
      <Dialog 
        open={openSignUp} 
        onClose={() => setOpenSignUp(false)} 
        maxWidth="xs" 
        fullWidth
        fullScreen={isMobile} // 모바일에서는 전체 화면으로 보기 쉽게 전환
      >
        <DialogTitle sx={{ fontWeight: 'bold', pt: { xs: 3, sm: 2 } }}>회원가입</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ mt: 1 }}>
            <TextField
              fullWidth
              label="이름 *"
              name="name"
              value={signUpData.name}
              onChange={handleSignUpChange}
            />
            <TextField
              fullWidth
              label="생년월일 (예: 19900101)"
              name="birthDate"
              value={signUpData.birthDate}
              onChange={handleSignUpChange}
            />
            <TextField
              fullWidth
              label="아이디 (미입력 시 이메일 사용)"
              name="loginId"
              value={signUpData.loginId}
              onChange={handleSignUpChange}
            />
            <TextField
              fullWidth
              label="비밀번호 *"
              name="password"
              type="password"
              value={signUpData.password}
              onChange={handleSignUpChange}
            />
            <TextField
              fullWidth
              label="이메일 *"
              name="email"
              value={signUpData.email}
              onChange={handleSignUpChange}
            />
            <TextField
              fullWidth
              label="교원자격증 번호 *"
              name="certNumber"
              value={signUpData.certNumber}
              onChange={handleSignUpChange}
            />
            <TextField
              fullWidth
              label="연락처 (예: 01012345678)"
              name="phone"
              value={signUpData.phone}
              onChange={handleSignUpChange}
            />
            <TextField
              fullWidth
              label="주소"
              name="address"
              value={signUpData.address}
              onChange={handleSignUpChange}
            />
          </Stack>
        </DialogContent>
        <DialogActions sx={{ p: { xs: 2, sm: 2 } }}>
          <Button onClick={() => setOpenSignUp(false)} size="large">취소</Button>
          <Button onClick={handleSignUpSubmit} variant="contained" size="large">가입하기</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Login;